module.exports = __webpack_public_path__ + "static/media/ucomb_bank.dd1c37ac.svg";